import Image from "next/image";
import Link from "next/link";

import { useTranslation } from "@flare/i18n";
import { Button, Heading, Text } from "@flare/ui/components";

export function ConfirmationSection({
  ctaText,
  ctaUrl,
  showCta,
  status,
  title,
  subtitle,
  ctaClickHandler,
  children,
}: {
  children?: React.ReactNode;
  ctaClickHandler?: () => void;
  ctaText: string;
  ctaUrl: string;
  showCta: boolean;
  status: string;
  subtitle?: string;
  title: string;
}) {
  const { t } = useTranslation();

  return (
    <>
      <Image
        src="/next/images/funnel/hands.png"
        alt={t("FUNNEL_STEP_CONFIRMATION_IMG_ALT")}
        width={70}
        height={70}
        className="rounded-full bg-success md:mt-sp-7"
      />
      <Text
        className="mt-sp-7 uppercase text-action md:mt-sp-8"
        variant="body1-highlight"
      >
        {status}
      </Text>

      <Heading variant="h2" className="mt-sp-4" textWrap="pretty" as="h1">
        {title}
      </Heading>

      {subtitle && <Text className="my-sp-2 md:my-sp-4">{subtitle}</Text>}

      {children}

      {showCta && (
        <Button
          type="button"
          size="lg"
          className="mt-sp-8 md:my-sp-8 md:max-w-[350px]"
          asChild
          fullWidth
          onClick={ctaClickHandler}
        >
          <Link href={ctaUrl}>{ctaText}</Link>
        </Button>
      )}
    </>
  );
}
